var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEwiChatbotToolHoverLogo = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 8C0 3.58172 3.58172 0 8 0H28C32.4183 0 36 3.58172 36 8V28C36 32.4183 32.4183 36 28 36H8C3.58172 36 0 32.4183 0 28V8Z",
    fill: "#D5DFEB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 10.9167V25.0833M10.5 15.8333C10.5 13.9667 10.5 13.0333 10.8633 12.32C11.1829 11.6928 11.6928 11.1829 12.32 10.8633C13.0333 10.5 13.9667 10.5 15.8333 10.5H20.1667C22.0333 10.5 22.9667 10.5 23.68 10.8633C24.3072 11.1829 24.8171 11.6928 25.1367 12.32C25.5 13.0333 25.5 13.9667 25.5 15.8333V20.1667C25.5 22.0333 25.5 22.9667 25.1367 23.68C24.8171 24.3072 24.3072 24.8171 23.68 25.1367C22.9667 25.5 22.0333 25.5 20.1667 25.5H15.8333C13.9667 25.5 13.0333 25.5 12.32 25.1367C11.6928 24.8171 11.1829 24.3072 10.8633 23.68C10.5 22.9667 10.5 22.0333 10.5 20.1667V15.8333Z",
    stroke: "#1E1E1E",
    strokeWidth: 1.25,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEwiChatbotToolHoverLogo);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/EWI_chatbot_tool_hover_logo.d9963c643e5432074c519604c12e8ea5.svg";